import * as React from 'react';
import { ReferenceField } from 'gossamer-unified';
import { RecordPicker } from './RecordPicker';
import { UneditableReference } from './UneditableReference';

export interface ReferenceProps {
  className?: string;
  clearOnSelection?: boolean;
  editable: boolean;
  field: ReferenceField;
  onItemSelected: (newValue: string | null) => void;
  suppressLink?: boolean;
  validity?: boolean;
  value: string;
}

export const ReferenceLookupNonBlankValue: React.FC<ReferenceProps> = (props) => {
  if (props.editable) {
    return <RecordPicker {...props} />;
  } else {
    return (
      <UneditableReference
        refEntity={props.field.refEntity}
        suppressLink={props.suppressLink}
        value={props.value}
        linkURL={props.field.linkURL}
      />
    );
  }
};

export const Reference: React.FC<ReferenceProps> = (props) => {
  const skipLookup =
    props.field.refEntity.skipReferenceLookup && props.field.refEntity.skipReferenceLookup(props.value);

  if (!props.value) {
    if (props.editable) {
      return <RecordPicker {...props} />;
    } else {
      return null;
    }
  } else {
    if (skipLookup) {
      if (props.editable) {
        return <RecordPicker {...props} altText={props.value} />;
      } else {
        return <span>{props.value}</span>;
      }
    } else {
      return <ReferenceLookupNonBlankValue {...props} />;
    }
  }
};
